import FeaturedSolutions from "../../components/FeaturedSolutions";
import LogoMini from "../../components/icons/LogoMini";
import AppGuest from "../../assets/img/Featured/app-guest.png";
import AppBook from "../../assets/img/Featured/app-booking.png";
import AppReserve from "../../assets/img/Featured/app-reservations.png";
import AppMembership from "../../assets/img/Featured/app-membership.png";
import AppAnni from "../../assets/img/Featured/app-anniversary.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../context/DataProvider";
import { Header } from "../../components/Header";
const EngagementPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash engagementPage">
            <Header />
            <div className="background" />
            <div className="page-header">Initial Engagement</div>
            <div className="text-blocks">
                <div className="std-text">
                    Boosting new guest bookings and growing repeat
                    guest revenue demands solutions that engage
                    guests at every point in the decision process.{'\n\n'}
                </div>
                <div className="std-text">
                    Optimize the new guest experience by providing
                    an effortless reservation process that allows
                    booking a single room or multiple rooms at once
                    while attractively presenting all of the promotions,
                    amenities and options your property has to offer.{'\n\n'}
                </div>
                <div className="std-text">
                    Encourage repeat visits with personalized offers
                    informed by past choices, stored preferences and
                    profile information like birthdays and
                    anniversaries.
                </div>
            </div>
            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Engagement", "Guest App");
                    addFlow("Guest App");
                    navigate("/solutions/guest-app")}}>
                    <div className="item-head">
                        <LogoMini />
                        Guest App
                    </div>
                    <img src={AppGuest} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Engagement", "Book");
                    addFlow("Book");
                    navigate("/solutions/book")}}>
                    <div className="item-head">
                        <LogoMini />
                        Book
                    </div>
                    <img src={AppBook} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Engagement", "Reserve");
                    addFlow("Reserve");
                    navigate("/solutions/reserve")}}>
                    <div className="item-head">
                        <LogoMini />
                        Reserve
                    </div>
                    <img src={AppReserve} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Engagement", "Loyalty & Promotions");
                    addFlow("Loyalty & Promotions");
                    navigate("/solutions/loyalty")}}>
                    <div className="item-head">
                        <LogoMini />
                        Loyalty & Promotions
                    </div>
                    <img src={AppMembership} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Engagement", "Digital Marketing");
                    addFlow("Digital Marketing");
                    navigate("/solutions/marketing")}}>
                    <div className="item-head">
                        <LogoMini />
                        Digital Marketing
                    </div>
                    <img src={AppAnni} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}

export default EngagementPage;